import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { RepairLocationFilterForm } from '../../../form-model/repair-location-filter.form.model';
import { RepairLocationService } from '../../../services/repair-location.service';
import { CodeDescription } from '../../../models/code-description.model';
import '@maersk-global/mds-components-core/mc-multi-select';
import '@maersk-global/mds-components-core/mc-option';
import '@maersk-global/mds-components-core/mc-button';

@Component({
  selector: 'app-repair-location-advanced-filter',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './repair-location-advanced-filter.component.html',
  styleUrl: './repair-location-advanced-filter.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairLocationAdvancedFilterComponent implements OnInit {
  @Input({ required: true }) repairLocationFilterForm!: FormGroup<RepairLocationFilterForm>;

  codeDescriptionList: CodeDescription[] = [];
  isLoadingOptions = false;

  constructor(
    private readonly repairLocationService: RepairLocationService,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.addControlsToFormGroup();
    this.loadCodeDescriptionOptions();
  }

  private addControlsToFormGroup(): void {
    if (!this.repairLocationFilterForm.get('repairLocationCodeList')) {
      this.repairLocationFilterForm.addControl('repairLocationCodeList', this.formBuilder.control<string[] | null>(null));
    }
    if (!this.repairLocationFilterForm.get('applyRepairLocationFilter')) {
      this.repairLocationFilterForm.addControl('applyRepairLocationFilter', this.formBuilder.control<boolean | null>(null));
    }
  }

  private loadCodeDescriptionOptions(): void {
    this.isLoadingOptions = true;
    this.repairLocationService.getAllCodeDescriptions().subscribe({
      next: (data) => {
        this.codeDescriptionList = data;
        this.isLoadingOptions = false;
      },
      error: () => {
        this.codeDescriptionList = [];
        this.isLoadingOptions = false;
      },
    });
  }

  applyFilters(): void {
    this.repairLocationFilterForm.get('applyRepairLocationFilter')?.setValue(true);
  }

  clearFilters(): void {
    this.repairLocationFilterForm.reset({ repairLocationCodeList: null });
    this.repairLocationFilterForm.get('applyRepairLocationFilter')?.setValue(true);
  }
}
